export default __webpack_public_path__ + "static/media/poker-planning.f16bed7e.png";